<script>
import plans from '@/plans';
import { defFilter } from '../plans';
import { props } from '@/plans/mx/shopping-cart';

export default {
  props: {
    ...props,
    filter: {
      type: Function,
      default: defFilter,
    },
    filterKeys: {
      type: Array,
      default: () => [],
    },
  },

  render(h) {
    return h(
      'div',
      {},
      this.filter(plans, this.filterKeys).map((x) =>
        h(x.components?.cart, {
          ...this.$attrs,
          props: { ...this.$props, $pkg: x },
          on: {
            ...this.$listeners,
          },
        }),
      ),
    );
  },
};
</script>


